import mainLogo from '../../images/Recol/recol_logo_main.webp';
import squareLogo from '../../images/Recol/recol_logo_square_small.png';
import bannerLogoWhite from '../../images/Recol/recreio_logo_square_white.png';
import banner01 from '../../images/Recol/recol_banner_01.jpg';
import banner02 from '../../images/Recol/recol_banner_02.jpg';
import banner03 from '../../images/Recol/recol_banner_03.jpg';
import car123 from '../../images/Recol/123_golf.jpg';
import box123 from '../../images/Recol/123_vw.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Recol',
    defaultStoreLink: 'peças.recol.com.br',
    defaultContactEmail: 'marketplace1185@recolveiculos.com.br',
    whatsappNumber: '68 98401 4691',
    CNPJname: 'RECOL VEICULOS LTDA',
    CNPJ: '05.496.472/0001-09',
    CNPJaddress: 'Via Chico Mendes, 1-2001 - Vila do Dner, Rio Branco - AC, CEP 69906-150',
    launchDate: '01/08/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "RECOL VEICULOS",
    ],

    disabledSellers: [],

    useMktNames: true,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.KitsDiscountValue
        },
        {
            name: 'Kits Óleos',
            img: 'tabOleos',
            products: SliderProducts.KitsOilDiscountValue
        },
        {
            name: 'Kits Correias',
            img: 'tabCorreias',
            products: SliderProducts.KitsChainDiscountValue
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    bannerBrands: '',
    aboutUsBg: banner03,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen</span> direto da concessionária <span style="font-weight: bold;">Recol</span>.',
    aboutUs: {
        title: 'Sobre nós',
        content: [
            'O Grupo Recol nasceu em Rio Branco, Acre, com a missão de oferecer excelência no atendimento e as melhores soluções em veículos para os nossos clientes e parceiros. Com décadas de experiência e comprometimento, temos orgulho em sermos uma referência em qualidade, inovação e confiança no mercado automotivo da região.',
            'Nosso grupo é composto por concessionárias que representam marcas de prestígio e reconhecidas pela tecnologia e pelo desempenho, garantindo aos nossos clientes a oportunidade de experimentar o que há de melhor no setor. Oferecemos uma linha completa de automóveis e motos, com serviços de vendas, assistência técnica especializada, peças e acessórios originais, tudo para assegurar uma experiência de compra satisfatória e duradoura.',
            'Acreditamos no desenvolvimento da nossa comunidade e temos como propósito contribuir para o crescimento econômico e social do Acre. Nossa equipe é formada por profissionais dedicados, que buscam aprimorar constantemente o conhecimento e o relacionamento com os nossos clientes, sempre pautados nos valores de ética, respeito e transparência.',
            'No Grupo Recol, cada cliente é uma parceria para a vida. Trabalhamos para que sua experiência conosco seja marcada pela confiança, pela qualidade e pela certeza de ter feito a melhor escolha. Aqui, você encontra mais do que veículos; encontra pessoas comprometidas em realizar sonhos e superar expectativas.'
        ],
        link: 'https://www.recolveiculos.com.br/quem-somos',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/recolveiculos/',
        Facebook: 'https://www.facebook.com/Veiculosrecol',
        LinkedIn: 'https://br.linkedin.com/company/gruporecol',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}